export default "__VITE_ASSET__ef55eda2__"